// extracted by css-extract-rspack-plugin
export default {"root":"sR7g1","sidebar":"qxR3i"};